export default __webpack_public_path__ + "static/shattered-6e5e9717c5051156ff1dc53d95de18a9.png";